// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_k6-1";
export var quotedThread = "_k6-0";